module.exports = __webpack_public_path__ + "img/equity-account1.471d1bd9.png";